.goldCardLink {
  display: block;
  width: 100%;
  height: 100%;
}

.goldCardLink * {
  cursor: pointer;
}

.goldCard:hover {
  border-color: var(--colors-transparent-black-twenty);
}

.imageArea {
  display: none;
}

.placeholderImage {
  aspect-ratio: 2 / 1;
  background: var(--background-color);

  /* Apply black or white text depending on the background */
  color: oklch(from var(--background-color) clamp(0, (0.6 - l) * 999, 1) 0 0deg);
}

@media (--reefer-media-tablet-min) {
  .imageArea {
    display: block;
  }
}
